<template>
    <button
        type="button"
        class="inline-flex items-center justify-center px-4 py-2 text-sm font-medium leading-5 transition duration-150 ease-in-out border rounded-full primary-button-hover-border primary-button-border primary-button-hover-text primary-button-text primary-button-bg primary-button-hover-bg focus:outline-none"
        :class="{ 'opacity-70 cursor-not-allowed': disabled }"
        :disabled="disabled || processing"
    >
        <loading-icon :visible="processing"></loading-icon>
        <slot></slot>
    </button>
</template>

<script>
import LoadingIcon from '@/components/ui/LoadingIcon.vue';
export default {
    name: 'primary-button',

    components: {
        LoadingIcon,
    },

    props: {
        disabled: {
            default: false,
        },

        processing: {
            default: false,
        },
    },
};
</script>
